import React, { useState, useEffect } from 'react';
import { X, Smartphone, ArrowRight } from 'lucide-react';
import { useRegisterBanner } from '../contexts/BannerQueueContext';

const CrossAppBanner = () => {
    const [isVisible, setIsVisible] = useState(true);

    const { isActive } = useRegisterBanner('crossAppPromo', 4, isVisible);

    // Environment detection: In the frontend (Web) app, we promote GigShip Go.
    // If we want this component to be shared, we can use an environment variable.
    // For now, in this repo, we assume it's the Main/Web App.
    const isMainApp = true;

    useEffect(() => {
        const dismissed = localStorage.getItem('gigship_mobile_banner_dismissed');
        if (dismissed) {
            setIsVisible(false);
        }
    }, []);

    const handleDismiss = () => {
        setIsVisible(false);
        localStorage.setItem('gigship_mobile_banner_dismissed', 'true');
    };

    if (!isVisible || !isActive) return null;

    return (
        <div className="bg-gradient-to-r from-blue-600 to-indigo-700 text-white shadow-md">
            <div className="max-w-7xl mx-auto py-4 px-3 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
                    <div className="flex-1 flex flex-col space-y-3">
                        {/* 
                            Adaptive Logic: 
                            If in Main App, promote GigShip Go.
                            If in GigShip Go (future/shared context), promote Main App.
                        */}

                        {!isMainApp && (
                            /* GigShip Main App Section - Shown in Go App */
                            <div className="flex items-center">
                                <span className="flex p-1.5 rounded-lg bg-blue-800">
                                    <Smartphone className="h-5 w-5 text-white" aria-hidden="true" />
                                </span>
                                <div className="ml-3 flex flex-col sm:flex-row sm:items-center sm:gap-4">
                                    <p className="font-medium text-white text-sm sm:text-base">
                                        <span className="font-bold">Have a complex request?</span> Switch to the full GigShip app!
                                    </p>
                                    <a
                                        href="https://www.gigship.com"
                                        className="inline-flex items-center text-xs font-semibold text-white hover:underline bg-white/10 px-2 py-1 rounded"
                                    >
                                        Switch to the full GigShip app <ArrowRight className="ml-1 h-3 w-3" />
                                    </a>
                                </div>
                            </div>
                        )}

                        {isMainApp && (
                            /* GigShip Go Section - Shown in Main/Web App */
                            <div className="flex items-center">
                                <span className="flex p-1.5 rounded-lg bg-orange-600">
                                    <Smartphone className="h-5 w-5 text-white" aria-hidden="true" />
                                </span>
                                <div className="ml-3 flex flex-col sm:flex-row sm:items-center sm:gap-4">
                                    <p className="font-medium text-white text-sm sm:text-base">
                                        <span className="font-bold text-orange-200">Try GigShip Go:</span> Find instant gigs and tasks near you!
                                    </p>
                                    <a
                                        href="https://www.gigship.com/go"
                                        className="inline-flex items-center text-xs font-semibold text-white hover:underline bg-orange-500/20 px-2 py-1 rounded"
                                        onClick={(e) => {
                                            // Handle redirection or show coming soon if external links are not ready
                                            // but based on user code, we use /go
                                            // e.preventDefault();
                                            // alert("Link to GigShip Go App Store / Play Store coming soon!");
                                        }}
                                    >
                                        Get GigShip Go <ArrowRight className="ml-1 h-3 w-3" />
                                    </a>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="order-2 flex-shrink-0 flex items-center justify-end">
                        <button
                            type="button"
                            className="p-2 rounded-md hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-white"
                            onClick={handleDismiss}
                        >
                            <span className="sr-only">Dismiss</span>
                            <X className="h-6 w-6 text-white" aria-hidden="true" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CrossAppBanner;
